import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  InputAdornment,
  Tooltip,
  Avatar,
  Select,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import imageCompression from "browser-image-compression";
//Icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
// import { CREATE_USER } from "../../Schema/User";
import CropImageFile from "../CropImage/CropImageFile";
import { UPDATE_MATERIAL_NAME } from "../../Schema/MaterialName";
import {
  SelectUnit,
  SelectCategory,
  SelectGroup,
} from "../Include/DynamicSelect";

export default function UpdateMaterialName({
  editData,
  open,
  handleClose,
  setRefetch,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [unitVal, setUnitVal] = useState({ id: "", title: "" });
  const [categoryVal, setCategoryVal] = useState({ id: "", title: "" });
  const [groupVal, setGroupVal] = useState({ id: "", title: "" });

  // ========================= upload Image =========================
  const [profileHook, setProfileHook] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [openCrop, setOpenCrop] = useState(false);

  const handleUploadImage = async (e) => {
    const imageFile = e.target.files[0];

    const options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    const compressedFile = await imageCompression(imageFile, options);
    var newFile = new File([compressedFile], `${imageFile.name}.png`, {
      type: "image/png",
    });

    if (newFile) {
      setImageFile(newFile);
      setPhotoURL(URL.createObjectURL(newFile));
      setOpenCrop(true);
    }
  };

  //hiden and show vibility
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const [updateMaterialName] = useMutation(UPDATE_MATERIAL_NAME, {
    onCompleted: ({ updateMaterialName }) => {
      setLoading(false);
      // console.log("updateMaterialName::", updateMaterialName);
      if (updateMaterialName?.status) {
        setAlert(true, "success", updateMaterialName?.message);
        handleClose();
        resetForm();
        setRefetch();
        setGroupVal({ id: "", title: "" });
        setCategoryVal({ id: "", title: "" });
        setUnitVal({ id: "", title: "" });
      } else {
        // console.log("updateMaterialName::", updateMaterialName);
        setAlert(true, "error", updateMaterialName?.message);
      }
    },
    onError: (error) => {
      // console.log("updateMaterialName::", createUser);
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    categoryId: Yup.string().required("require!"),
    groupId: Yup.string().required("require!"),
    materialEnName: Yup.string().required("require!"),
    materialKhName: Yup.string().required("require!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      categoryId: "",
      groupId: "",
      materialEnName: "",
      materialKhName: "",
      remark: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      updateMaterialName({
        variables: {
          id: editData?._id,
          input: {
            materialEnName: values?.materialEnName,
            materialKhName: values?.materialKhName,
            remark: values?.remark,
            categoryId: values?.categoryId,
            groupId: values?.groupId,
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  useEffect(() => {
    if (categoryVal?.id) {
      setFieldValue("categoryId", categoryVal?.id);
    }
  }, [categoryVal?.id]);

  useEffect(() => {
    if (groupVal?.id) {
      setFieldValue("groupId", groupVal?.id);
    }
  }, [groupVal?.id]);

  useEffect(() => {
    if (editData) {
      setFieldValue("remark", editData?.remark);
      setFieldValue("materialEnName", editData?.materialEnName);
      setFieldValue("materialKhName", editData?.materialKhName);

      setGroupVal({
        id: editData?.groupId?._id,
        title: editData?.groupId?.groupKhName,
      });
      setFieldValue("groupId", groupVal?.id);

      setCategoryVal({
        id: editData?.categoryId?._id,
        title: editData?.categoryId?.categoryKhName,
      });
      setFieldValue("categoryId", categoryVal?.id);
    }
  }, [editData]);
  // console.log("editData", editData)
  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">កែប្រែឈ្មោះសម្ភារៈ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={6}>
                <Typography className="field-title">សម្ភារៈជាខ្មែរ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="សម្ភារៈជាខ្មែរ"
                  {...getFieldProps("materialKhName")}
                  error={Boolean(
                    touched.materialKhName && errors.materialKhName
                  )}
                  helperText={touched.materialKhName && errors.materialKhName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">
                  សម្ភារៈជាអង់គ្លេស
                </Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ទំហំជាអង់គ្លេស"
                  {...getFieldProps("materialEnName")}
                  error={Boolean(
                    touched.materialEnName && errors.materialEnName
                  )}
                  helperText={touched.materialEnName && errors.materialEnName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">ប្រភេទ</Typography>
                <SelectCategory
                  selectedVal={categoryVal}
                  setSelectedVal={setCategoryVal}
                  isUse={true}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">ក្រុម</Typography>
                <SelectGroup
                  isUse={true}
                  selectedVal={groupVal}
                  setSelectedVal={setGroupVal}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    កែប្រែ
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
